import React from 'react';
import AppBar from '../../commons/AppBar'
import SpecificComponent from '../../commons/SpecificComponent';
import ButtonsModules from '../../commons/ButtonsModules';
import Utils from '../../providers/Utils';
import { Divider, Grid, FormControl, InputLabel, Select, Input, MenuItem, TextField, Button, Table, TableHead, TableRow, TableCell, TableBody } from '@material-ui/core';
import LocalStorage from '../../providers/LocalStorage';
import Ws from '../../providers/Ws';
import FromServer from './FromServer';
import Models from './Models';
import SiteMap from '../../commons/SiteMap';

export default class Planificare extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            nrYear: new Date().getFullYear(),
            listYears: new Utils().yearsPlus5(),
            strCont: '',
            strTip: 'Venituri',
            listaConturi:new Models().listaConturi.filter(t => t.tip === 'Venituri')[0].conturi,
            listTipuri: ['Venituri', 'Cheltuieli'],
            nrValoare: 0,
            listPlan:[],
            mapButtons: [{ id: 'financiarcontabil', label: 'Inapoi Financiar', color: '#900DCB' },
           ]

        }
    }

    componentDidMount() {
        this.getListPlanificare()

        // console.log('this.state.listaConturi :', this.state.listaConturi);
    }


    getListPlanificare = async () => {

        let fs = new FromServer()

        let getListPlan = await fs.getListPlanificare()
      
        if (getListPlan.r) {
            this.setState({
                listPlan: getListPlan.c
            })
        }

    }

    insertListPlanificare = async () => {

    

        let ls = new LocalStorage()


        let objToInsert = {
            an: this.state.nrYear,
            tip: this.state.strTip,
            cont: this.state.strCont,
            valoare: this.state.nrValoare,
            id_cine_introdus: ls.GetUserData().InfoUser.IdUser,
            cand_introdus: new Date(),
        }

       let fs = new FromServer()

       let insertPlan = await fs.insertListPlan(objToInsert)

        if (insertPlan.r) {
            this.getListPlanificare()
        }
    }

    deleteRow = async(l) =>{
        
        let fs = new FromServer();

        let delRow = await fs.deleteRowPlan({sters:1}, {id:l.id})

        if(delRow.r){
            this.getListPlanificare()
        }
    }

    changeTip = (ev) =>{
        this.setState({
            strTip:ev.target.value,
            listaConturi:new Models().listaConturi.filter(t => t.tip === ev.target.value)[0].conturi
        })
    }

    goTo = (id) => {
        this.props.history.push(`/${id}`)
    }

    render() {
        return (
            <div>
     
          <ButtonsModules history={this.props.history}
                    scop={'Financiar'} />

                <Divider className='pm-divider' />
                <div style={{ textAlign: 'left' }}>
                    {this.state.mapButtons.map((b, idx) => {
                        return (
                            <SiteMap
                                key={idx}
                                b={b}
                                buttonSelected={this.goTo} />

                        )
                    })}
                </div>
                <h2 className='pm-title'>{this.dictionary.appBar.drawer.planificare}</h2>

                <Grid className='container' container>
                    <Grid item xs={12} sm={12} md={3} lg={3} xl={3} >
                        <FormControl className='inputFocus' style={{ width: '90%', marginTop: 16 }}>
                            <InputLabel htmlFor="resursa">{this.dictionary.financiarContabil.selecteazaAnul}</InputLabel>
                            <Select

                                value={this.state.nrYear || ""}
                                onChange={(ev) => { this.setState({ nrYear: ev.target.value }) }}

                                input={<Input id="resursa" />}>


                                {this.state.listYears.map((s, idx) => {
                                    return <MenuItem value={s} key={idx}  > {s}</MenuItem>

                                })
                                }
                            </Select>
                        </FormControl>


                    </Grid>
                    

                    <Grid item xs={12} sm={12} md={3} lg={3} xl={3} >
                        <FormControl className='inputFocus' style={{ width: '90%', marginTop: 16 }}>
                            <InputLabel htmlFor="resursa">{this.dictionary.financiarContabil.tip}</InputLabel>
                            <Select

                                value={this.state.strTip || ""}
                                onChange={this.changeTip}

                                input={<Input id="resursa" />}>


                                {this.state.listTipuri.map((s, idx) => {
                                    return <MenuItem value={s} key={idx}  > {s}</MenuItem>

                                })
                                }
                            </Select>
                        </FormControl>


                    </Grid>

                    <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={3} lg={3} xl={3} >

                    <FormControl className='inputFocus' style={{ width: '90%', marginTop: 16 }}>
                            <InputLabel htmlFor="resursa">{this.dictionary.financiarContabil.cont}</InputLabel>
                            <Select

                                value={this.state.strCont || ""}
                                onChange={(ev)=>{this.setState({strCont:ev.target.value})}}

                                input={<Input id="resursa" />}>


                                {this.state.listaConturi.map((s, idx) => {
                                    return <MenuItem value={s.cont} key={idx}  > {s.cont}:{s.descriere}</MenuItem>

                                })
                                }
                            </Select>
                        </FormControl>
                        

                    </Grid>
                    <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={3} lg={3} xl={3} >
                        <TextField
                            className="inputFocus loginTextField"
                            style={{ width: '90%' }}
                            label={this.dictionary.financiarContabil.valoare}
                            value={this.state.nrValoare || ''}
                            onChange={(ev) => { this.setState({ nrValoare: ev.target.value }) }}
                            margin="normal"
                            type='number'

                        />

                    </Grid>
                    <Grid style={{ width: 'fit-content' }} className="loginButton" item xs={12} sm={12} md={12} lg={12} xl={12} >
                        <Button onClick={this.insertListPlanificare} style={{ width: 'fit-content' }} className='pm-login-button' variant="outlined">{this.dictionary.comune.save}</Button>
                    </Grid>

                    {this.state.listPlan.length > 0 &&

                        <Table style={{ width: '90%', margin: 'auto' }}>
                            <TableHead>
                                <TableRow style={{}}>

                                    <TableCell style={{ fontSize: 14, fontWeight: 600, textAlign: 'center' }}>
                                        {this.dictionary.financiarContabil.selecteazaAnul}
                                    </TableCell>
                                    <TableCell style={{ fontSize: 14, fontWeight: 600, textAlign: 'center' }}>
                                       {this.dictionary.financiarContabil.cont}
                                    </TableCell>
                                    <TableCell style={{ fontSize: 14, fontWeight: 600, textAlign: 'center' }}>
                                    {this.dictionary.financiarContabil.tip}
                                    </TableCell>
                                    <TableCell style={{ fontSize: 14, fontWeight: 600, textAlign: 'center' }}>
                                    {this.dictionary.financiarContabil.valoare}
                                    </TableCell>


                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {this.state.listPlan.map((l, idx) => {
                                    return (
                                        <TableRow  style={{ cursor: 'pointer' }} key={idx}>
                                            <TableCell style={{ textAlign: 'center' }}>
                                                {l.an}
                                            </TableCell>

                                            <TableCell style={{ textAlign: 'center' }} >
                                                {l.cont}
                                            </TableCell>
                                            <TableCell style={{ textAlign: 'center' }} >
                                                {l.tip}
                                            </TableCell>
                                            <TableCell style={{ textAlign: 'center' }} >
                                                {l.valoare}
                                            </TableCell>
                                            <TableCell style={{ textAlign: 'center' }} >
                                                        <i onClick={()=>{this.deleteRow(l)}} style={{color:'#dc2b2b'}} className='material-icons'>delete</i>
                                                    </TableCell>

                                        </TableRow>
                                    )
                                })}
                            </TableBody>
                        </Table>
                    }

                </Grid>
            </div>
        );
    }
}